<template>
  <div class="common-page-main main-page">
    <div class="field-box">
      <div class="page-top-bar cfa">
        <div class="headline lfp">
          <span>Menu Management</span>
        </div>
        <div class="rfp">
          <el-button size="small" icon="plus" type="primary" @click="showAddPop()">add</el-button>
        </div>
      </div>
      <el-row class="content-wrap" :gutter="20">
        <el-col :span="8">
          <div class="page-left-wrap">
            <div class="sub-top-bar cfa">
              <div class="title lfp">menu group</div>
              <div class="rfp">
              </div>
            </div>
            <el-tree :data="treeData" :props="moduleProp" :expand-on-click-node="false" :highlight-current="true" :default-expand-all="true" @node-click="clickModuleTree" :render-content="renderTreeItemContent"></el-tree>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="page-right-wrap">
            <div class="sub-top-bar cfa">
              <div class="title lfp">Menu</div>
              <div class="rfp">
              </div>
            </div>
            <el-table :data="tableData" element-loading-text="LOADING" style="width: 100%">
              <el-table-column prop="MoName" label="Name"></el-table-column>
              <el-table-column prop="MoSort" label="Sort"></el-table-column>
              <el-table-column label="operate">
                <template scope="scope">
                  <el-button size="small" v-on:click="showUpdatePop(scope.$index, scope.row)">detail set</el-button>
                  <el-button size="small" v-on:click="handleDel(scope.$index, scope.row)">delete</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 详情弹出层 -->
    <el-dialog title="menu detail" :visible.sync="page.popShow" size="tine">
      <ModuleForm @addSuccess="handleAdd" @updateSuccess="handleUpdate" :moduleData="moduleData" :moduleProp="moduleProp" ref="popForm"></ModuleForm>
    </el-dialog>
  </div>
</template>

<script>
// import $ from 'jquery'
// import mixin from '@/components/common/mixin'
import tools from '@/components/common/tools'
import ModuleForm from '@/components/system/ModuleForm'
import tree from '@/components/common/tree'

// import storeTools from '@/store/tools'
// import storeConfig from '@/store/system'
// import * as types from '@/store/mutation-types'

// 请求相关操作
let page = {
  methods: {
    // 获得菜单
    getModuleListDataAjax() {
      tools.commonAjax.call(this, true, '/SystemManage/GetModuleList', {
        All: 1,
        OrderName: 'MO_SORT'
      }).then((res) => {
        let result = res.data
        result.push({
          MoFacode: '-1',
          MoCode: '0',
          MoName: 'All'
        })
        result.push({
          MoFacode: '0',
          MoCode: '-100',
          MoName: 'Other'
        })
        this.moduleData = result
        // this.dataStore.commit(types.UPDATE_MODULE, result)
      })
    },
    // 删除操作
    delDataAjax(id) {
      tools.commonAjax.call(this, true, '/SystemManage/DeleteModule', {
        Id: id
      }).then(() => {
        this.$message.success('delete success!')
        // 重新获取数据
        this.getModuleListDataAjax()
        // 重新获取登录用户信息
        this.$store.dispatch('getLoginMemberInfo', false)
      })
    }
  }
}

// 菜单树
let moduleTree = new tree.TreeCreate(function(item) {
  for (let key in item) {
    if (item.hasOwnProperty(key)) {
      this[key] = item[key]
    }
  }
}, { FId: 'MoFacode', Id: 'MoCode' })

export default {
  name: 'ModuleManagement',
  mixins: [page],
  components: {
    ModuleForm
  },
  created() {
    this.getModuleListDataAjax()
  },
  data() {
    return {
      // dataStore: storeTools.create(storeConfig),
      moduleData: [],
      moduleProp: {
        id: 'MoCode',
        label: 'MoName',
        level: '_level',
        children: 'children'
      },
      tree: {
        current: null
      },
      page: {
        popShow: false
      }
    }
  },
  computed: {
    // moduleData() {
    //   return this.dataStore.state.moduleData
    // },
    // moduleProp() {
    //   return this.dataStore.state.moduleProp
    // },
    // 侧边树数据
    treeData() {
      let treeFlatData = this.moduleData.filter(item => {
        return !item.IsLeaf
      })
      moduleTree.create(treeFlatData)
      let treeData = moduleTree.getTreeData()
      if (treeData[0]) {
        this.tree.current = treeData[0]
      }
      return treeData
    },
    // 表格数据
    tableData() {
      return this.moduleData.filter(item => {
        if (this.tree.current) {
          if (this.tree.current.MoCode === '-100') {
            // 其他(直接挂在根节点的菜单)
            return !!item.IsLeaf && item.MoFacode === '0'
          } else {
            return !!item.IsLeaf && item.MoFacode === this.tree.current.MoCode
          }
        } else {
          return false
        }
      })
    }
  },
  methods: {
    // 树节点点击事件
    clickModuleTree(item) {
      let current = this.tree.current
      if (current.MoCode !== item.MoCode) {
        this.tree.current = item
      }
    },
    // 渲染树节点内容
    renderTreeItemContent(h, { node, data, store }) {
      return (
        <span>
          <span>
            <span>{node.label}</span>
          </span>
          <span style="float: right; margin-right: 20px" v-show={data.Id}>
            <el-button size="mini" on-click={() => this.showUpdatePop(store, data)}>edit</el-button>
            <el-button size="mini" on-click={() => this.handleDel(store, data)}>delete</el-button>
          </span>
        </span>)
    },
    // 显示add弹出层
    showAddPop() {
      this.page.popShow = true
      this.$nextTick(function() {
        this.$refs.popForm.resetValue()
      })
    },
    // 显示修改弹出层
    showUpdatePop(idx, item) {
      this.page.popShow = true
      this.$nextTick(function() {
        this.$refs.popForm.setValue(item)
      })
    },
    // add操作
    handleAdd() {
      // 重新获取数据
      this.getModuleListDataAjax()
      this.page.popShow = false
    },
    // 修改操作
    handleUpdate() {
      // 重新获取数据
      this.getModuleListDataAjax()
      this.page.popShow = false
    },
    // 删除操作
    handleDel(idx, item) {
      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(() => {
        this.delDataAjax(item.Id)
      })
    }
  }
}
</script>

<style lang="scss">
@import "~@/style/lib-config";
</style>



// WEBPACK FOOTER //
// ModuleManagement.vue?59265a5e